import { TFunction } from 'i18next';

import {
  PersonalInformationPath,
  SecurityPath,
  SubscriptionPath,
} from '~/modules/settings/constants';

import { AccountMenuEntry } from './types';

export const getHomePageV2AccountMenuEntries = (
  t: TFunction,
  getSubscriptionTitle: (t: TFunction) => string,
): ReadonlyArray<AccountMenuEntry> => [
  {
    label: t('general:personal_information', 'Personal Information'),
    icon: 'general/personal info/24',
    action: 'navigate',
    path: PersonalInformationPath,
  },
  {
    label: getSubscriptionTitle(t),
    icon: 'credit-card/24',
    action: 'navigate',
    path: SubscriptionPath,
  },
  {
    label: t('general:password', 'Password'),
    icon: 'general/unlock/24',
    action: 'navigate',
    path: SecurityPath,
  },
  {
    label: t('general:app_language', 'App Language'),
    icon: 'globe/24',
    action: 'language',
    dividerBefore: true,
  },
  {
    label: t('general:help', 'Help'),
    icon: 'general/help-circle/24',
    action: 'help',
  },
  {
    label: t('general:logout', 'Logout'),
    icon: 'navigation/log-out/24',
    action: 'logout',
    dividerBefore: true,
  },
];
